import React from 'react';
import CommonButton from '../../../common/components/CommonButton';
import { CommonButtonVariants } from '../../../constants/CommonButtonVariants';
import nextGearCarIcon from '../../../assets/img/nextGear/next-gear-car.svg';
import { NEXT_GEAR_CAPITAL_URL } from '../../constants';

function NextGearHowItWorks() {
  const handleStartClick = () => {
    window.open(NEXT_GEAR_CAPITAL_URL);
  };

  const listItems = [
    {
      id: 'item-1',
      label: 'Apply and get approved',
    },
    {
      id: 'item-2',
      label: 'Bid and purchase as usual',
    },
    {
      id: 'item-3',
      label: 'Select NextGear Capital at checkout',
    },
    {
      id: 'item-4',
      label: 'Vendor is paid directly',
    },
  ];

  return (
    <section className="ng-how-it-works">
      <div className="ng-how-it-works__container">
        <div className="ng-how-it-works__inner">
          <div className="ng-how-it-works__content">
            <h2 className="ng-how-it-works__title">How it Works on The Stock Vault</h2>
            <ul className="ng-how-it-works__list">
              {listItems.map((item, index) => (
                <li key={item.id} className="ng-how-it-works__list-item">
                  <div className="ng-how-it-works__list-item-number">{index + 1}</div>
                  <span className="ng-how-it-works__list-item-content">{item.label}</span>
                </li>
              ))}
            </ul>
            <CommonButton
              label="Start with NextGear Capital"
              className="ng-how-it-works__button"
              variant={CommonButtonVariants.RED}
              handleClick={handleStartClick}
            />
            <img src={nextGearCarIcon} alt="NextGear Icon" className="ng-how-it-works__icon" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default NextGearHowItWorks;
